import ReactDOM from 'react-dom'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
import { AddBox, ArrowDownward } from "@material-ui/icons";

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import { ThemeBuilder } from './app/pages/settings/ThemeBuilder/themeBuilder'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)

// Silence a single third-party deprecation warning:
// material-table@1.69.3 still uses MUI v4's `onChangePage`; MUI v5 (installed
// alongside) warns because it was renamed to `onPageChange`. Not fixable in
// app code — remove when material-table is upgraded to v2+ or replaced.
const __origError = console.error;
console.error = (...args: any[]) => {
  const joined = args.map(a => (typeof a === 'string' ? a : '')).join(' ');
  // material-table passing MUI v4 prop names to MUI v5 TablePagination
  if (joined.includes('TablePagination')) return;
  // react-html-table-to-excel: buttonText propType is `string`, callers pass JSX
  if (joined.includes('ReactHTMLTableToExcel') && joined.includes('buttonText')) return;
  // react-big-calendar internally renders <div> inside <p> via its tooltip
  if (joined.includes('ReactBigCalendar') && joined.includes('validateDOMNesting')) return;
  __origError.apply(console, args);
};

Chart.register(...registerables)

const queryClient = new QueryClient()

ReactDOM.render(
  
  <QueryClientProvider client={queryClient}>
    <MetronicI18nProvider>
      <AuthProvider>  
        <AppRoutes />
      </AuthProvider>
    </MetronicI18nProvider>
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </QueryClientProvider>,
  document.getElementById('root')
  
)
